import { MATCH_FORMAT } from '../../../constants/matchFormats'

export const RESTRICTED_FIELDS = [
  'name',
  'league_type',
  'rules',
  'entry_fee',
  'season',
  'play_start',
  'play_end',
  'registration_start',
  'registration_end',
  'age_category',
  'gender',
  'region_id',
  'timezone',
  'match_format',
  'min_players_per_division',
  'max_players_per_division',
  'max_registrations',
  'public_visible',
  'banner_url',
]

// Used by hasRestrictedChanges to DETECT whether any pre-submission field changed.
// All RESTRICTED_FIELDS qualify for change detection so the owner confirmation modal
// is triggered whenever any restricted field is modified.
export const RESTRICTED_FIELDS_FOR_CHANGE_DETECTION = RESTRICTED_FIELDS

// Fields actually DISPLAYED inside the owner confirmation modal.
// Intentionally a strict subset of RESTRICTED_FIELDS_FOR_CHANGE_DETECTION.
export const OWNER_CONFIRMATION_FIELDS = [
  'league_type',
  'age_category',
  'gender',
  'registration_start',
  'registration_end',
  'play_start',
  'play_end',
  'min_players_per_division',
  'max_players_per_division',
  'max_registrations',
]

export const RESTRICTED_FIELDS_FOR_ADMINS = RESTRICTED_FIELDS

export const INITIAL_FORM_DATA = {
  name: '',
  league_type: '',
  rules: '',
  league_status: 'draft',
  entry_fee: '',
  season: '',
  play_start: '',
  play_end: '',
  registration_start: '',
  registration_end: '',
  age_category: '',
  gender: '',
  region_id: '',
  timezone: 'America/New_York',
  match_format: MATCH_FORMAT.TRADITIONAL,
  playoff_min_matches_required: 3,
  min_players_per_division: '',
  max_players_per_division: '',
  max_registrations: '',
  public_visible: false,
  banner_url: '',
  allowed_skill_levels: [],
}
